
import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class Section {
	constructor() {

		if( document.body.classList.contains('single-program') || document.body.classList.contains('post-type-archive-program') ){
			return;
		}

		gsap.utils.toArray(".section.flow-root:not(:last-child)").forEach((section, i) => {
			ScrollTrigger.create({
				trigger: section,
				start: "bottom bottom", // Quand le haut de la section touche le haut de l'écran
				pin: true,        // On "épingle" la section
				pinSpacing: false // On empêche GSAP d'ajouter de l'espace vide après
			});
		});

		// gsap.utils.toArray(".home .section-banner").forEach((section, i) => {
		// 	ScrollTrigger.create({
		// 		trigger: section,
		// 		start: "top top", // Quand le haut de la section touche le haut de l'écran
		// 		pin: true,        // On "épingle" la section
		// 		pinSpacing: false // On empêche GSAP d'ajouter de l'espace vide après
		// 	});
		// });
	}

}
